export function calculateInterest({
  depositAmount,
  durationMonths,
  depositType, // "one-time" or "periodic"
  depositFrequency, // "monthly", "quarterly", "half-yearly", "yearly"
  interestType, // "compound" or "flat"
  interestFrequency, // "monthly", "quarterly", "half-yearly", "yearly"
  annualInterestRate
}) {
  const getMonthsFromFrequency = (frequency) => {
    switch (frequency.toLowerCase()) {
      case "daily": return 1;
      case "monthly": return 1;
      case "quarterly": return 3;
      case "half yearly": return 6;
      case "yearly": 
      case "one time": return 12;
      default: throw new Error(`Invalid frequency: ${frequency}`);
    }
  };

  const depositInterval = getMonthsFromFrequency(depositFrequency);
  const interestInterval = getMonthsFromFrequency(interestFrequency);
  let totalDeposit = 0;
  let totalInterest = 0;

  if (depositType.toLowerCase() === "one-time") {
    totalDeposit = depositAmount;

    if (interestType.toLowerCase() === "flat") {
      totalInterest = (depositAmount * annualInterestRate / 100) * (durationMonths / 12);
    } else {
      let principal = depositAmount;
      for (let i = interestInterval; i <= durationMonths; i += interestInterval) {
        const interest = principal * (annualInterestRate / 100) * (interestInterval / 12);
        principal += interest;
        totalInterest += interest;
      }
    }
  } else {
    for (let i = 0; i < durationMonths; i += depositInterval) {
      totalDeposit += depositAmount;

      if (interestType.toLowerCase() === "flat") {
        const interest = (depositAmount * annualInterestRate / 100) * ((durationMonths - i) / 12);
        totalInterest += interest;
      } else {
        let principal = depositAmount;
        for (let j = i + interestInterval; j <= durationMonths; j += interestInterval) {
          const interest = principal * (annualInterestRate / 100) * (interestInterval / 12);
          principal += interest;
          totalInterest += interest;
        }
      }
    }
  }

  const maturityAmount = totalDeposit + totalInterest;
  const periods = durationMonths / interestInterval;
  const averageInterest = periods > 0 ? totalInterest / periods : 0;

  return {
        totalDeposit: Math.round(totalDeposit),
        totalInterest: Math.round(totalInterest),
        maturityAmount: Math.round(maturityAmount),
        averageInterest: Math.round(averageInterest)
    };
}